<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-2 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div
              class="py-4 pt-5 mb-3 row align-items-center white-bg border-1"
            >
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <i
                    class="fa fa-file-text-o primary-color card-icon"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <div class="py-1 col-md-7">
                <h4 class="primary-color font-600">
                  {{ $t("text.branch.dealerBranchesReport") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.branch.sendBranchesReport") }}
                </p>
              </div>
              <div class="col-md-3 flexify">
                <select class="form-control" v-model="sentStatus">
                  <option value="all">{{ $t("text.branch.all") }}</option>
                  <option value="true">{{ $t("text.branch.sent") }}</option>
                  <option value="false">{{ $t("text.branch.notSent") }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.branch.totalCount") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <i
                          class="text-white fa fa-file-text-o card-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ companiesCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row">
          <div class="text-left col-md-12">
            <router-link
              :to="{
                name: 'sendDealerReport',
                query: {
                  id: dealer ? dealer.id : '',
                  accessLevel: 'dealer',
                  forward: 'false',
                },
              }"
              class="btn btn-primary primary-bg primary-border"
            >
              {{ $t("text.branch.sendDealerReport") }}
            </router-link>
          </div>
        </div>
        <div class="mt-3">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="false"
            :allowSorting="true"
            :pageSettings="tableProps.pageSettings"
            :toolbar="tableProps.toolbar"
            :searchSettings="tableProps.search"
            :allowExcelExport="false"
            :allowPdfExport="false"
            :actionBegin="actionHandler"
            :toolbarClick="toolbarClick"
            :allowTextWrap="true"
            :locale="usedLang"
          >
            <e-columns>
              <e-column width="80" field="index" headerText="#"></e-column>
              <e-column
                :template="reportStatus"
                :headerText="$t('text.branch.status')"
                width="250"
              ></e-column>
              <e-column
                width="200"
                field="branch"
                :headerText="$t('text.branch.station')"
              ></e-column>
              <e-column
                width="200"
                field="company"
                headerText="Company "
              ></e-column>
              <e-column
                width="130"
                field="street"
                :headerText="$t('text.branch.address')"
              ></e-column>
              <e-column
                width="130"
                field="state"
                :headerText="$t('text.branch.state')"
              ></e-column>
              <e-column :template="reports" width="300"></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
          <div class="mt-3" style="margin: 0 auto">
            <Paginator
              v-show="!showLoader"
              :total-pages="totalPages"
              :per-page="pageSize"
              :current-page="currentPage"
              @pagechanged="onPageChange"
              @getPageSize="getPageSize"
              :pageSize="pageSize"
            />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Dealer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import CompanyUsersTemplate from "@/components/TableTemplates/companyUsers";
import UserStatusTemp from "@/components/Templates/userStatusTemp";
import Paginator from "@/components/Paginator.vue";
import Reports from "@/components/Templates/reportsTempalate";
import reportStatus from "@/components/Templates/reportStatus";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Users :: Epump Portal",
  name: "Users",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      sortingTable: false,
      sortType: "",
      sortColumn: "",
      searchValue: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      searchTotalPages: 1,
      showLoader: true,
      tableCount: 0,
      dealer: null,
      backgroundUrl,
      usersCount: 0,
      cardBackgroundUrl,
      showLoader: true,
      companiesCount: 0,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      tableProps: {
        pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
        toolbar: ["Search"],
        search: { operator: "contains", ignoreCase: true },
      },
      reports: function () {
        return {
          template: Reports,
        };
      },
      reportStatus: function () {
        return {
          template: reportStatus,
        };
      },
      sentStatus: "all",
    };
  },
  watch: {
    dealer(dealer) {
      if (dealer !== null) {
      }
    },
    sentStatus() {
      this.updateRouteQuery();
      this.getReports();
    },
    searchValue() {
      this.updateRouteQuery();
    },
  },
  created() {
    this.$eventHub.$on("dealer", (dealer) => {
      this.dealer = dealer;
    });
    if (this.$route.query.dealerId) {
      this.getDealerUsers();
    }
  },
  mounted() {
    if (this.$route.query.search) {
      document.querySelector(".e-input").value = this.$route.query.search;
      this.searchValue = this.$route.query.search;
    }
    if (this.$route.query.sent) {
      this.sentStatus =
        this.$route.query.sent == "all"
          ? "all"
          : this.$route.query.sent == "true"
          ? true
          : false;
    } else {
      this.sentStatus = "all";
    }

    $(".e-input").keyup(function (e) {
      if (e.keyCode === 13) {
        searchFun(e, 13);
      } else {
        searchFun(e, 1);
      }
    });
    const searchFun = (event, number) => {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      this.searchValue = value;
      if (number !== 13 && value.length > 3) {
        this.getReports();
      }
      if (number == 13) {
        this.getReports();
      }
      if (!value.length) {
        this.getReports();
      }
    };
    this.getReports();
  },
  methods: {
    updateRouteQuery() {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.search = this.searchValue;
      queries.sent = this.sentStatus;
      this.$router.replace({ query: queries });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    actionHandler: function (args) {
      if (args.requestType == "sorting") {
        if (args.direction) {
          this.sortType = args.direction;
          this.sortColumn = args.columnName;
        } else {
          this.sortType = "";
          this.sortColumn = "";
        }

        this.getReports();
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getPageSize(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.getReports.totalNumber / pageSize);
      this.getReports();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getReports();
    },
    getReports() {
      const searchQuery = this.$route.query.search
        ? this.$route.query.search
        : this.searchValue;
      const sentStatus =
        this.sentStatus == "all"
          ? ""
          : this.sentStatus == "true"
          ? `&sentStatus=true`
          : `&sentStatus=false`;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/branchDailyReports?pageIndex=${this.currentPage}&pageSize=${this.pageSize}&filterQuery=${searchQuery}${sentStatus}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          let index = 0 + (this.currentPage - 1) * this.pageSize;

          res.data.data.forEach((el, i) => {
            el.formattedStatus =
              el.status === "InvoiceOverDue"
                ? "Invoice Overdue"
                : el.status === "SuspendedReport"
                ? "Report suspended"
                : el.status === "NewReport"
                ? "New Report"
                : null;
            el.mode = "branch";
            if (el.hasTransaction) {
              if (!el.sent) {
                el.sentStatus = "Not sent";
              } else {
                el.sentStatus = "Sent";
              }
            } else {
              el.sentStatus = "No transaction";
            }

            el.index = ++index;
            el.state = el.state ? el.state : "N/A";
            el.city = el.city ? el.city : "N/A";
            el.street = el.street ? el.street : "N/A";
          });
          this.companiesCount = res.data.count;
          this.totalPages = Math.ceil(res.data.count / this.pageSize);
          this.tableCount = res.data.count;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
